import MainLayout from "../components/layouts/MainLayout";
import Hero from "../components/Hero";
import Container from "../components/Container";
import SectionQuestions from "../components/sections/SectionQuestions";
import SvgArrowDown from "../components/svg/SvgArrowDown";
import {useState} from "react";
import imageHeroDesktop from "../public/img/hero/faq_mobile.jpg";
import imageHeroMobile from "../public/img/hero/faq_mobile.jpg";
import SectionFloating from "../components/sections/SectionFloating";
import {generateTitle} from "../helpers/meta";
import Head from "next/head";
import {useRouter} from "next/router";
import localized from "../locale/locales";
import Title from "../components/Title";

export default function Faq() {
    const {locale} = useRouter();
    const {faq: lang} = localized[locale];

    const [activeItem, setActiveItem] = useState(null);

    return (
        <MainLayout>
            <Head>
                <title key="title">{generateTitle(lang.og.title)}</title>
                <meta key="og:title" property="og:title" content={generateTitle(lang.og.title)}/>
            </Head>

            <SectionFloating scheme="faq"/>
            <Hero direction="image-right"
                  imageDesktop={imageHeroDesktop}
                  imageMobile={imageHeroMobile}
                  className="relative items-end gap-6 md:gap-10 md:pt-5 accent-blue-800"
                  narrow={true}
            >
                <div className="flex flex-col gap-7 md:gap-5 md:pb-10">
                    <header>
                        <Title className="relative inline-block max-w-[14ch] md:max-w-[16ch]">
                            {lang.header.title.localize({
                                emoji: '<span class="absolute -right-1 -top-2 md:-right-7 md:top-10 -rotate-12 text-xl md:text-2xl">❓</span>',
                                emoji2: '<span class="absolute -right-9 top-1 md:-right-16 md:top-14 rotate-12 text-3xl md:text-4xl">❓</span>'
                            })}
                        </Title>
                    </header>
                </div>
            </Hero>

            <Container className="relative pt-10 md:pt-20 pb-20 md:pb-0">
                <div className="flex flex-col gap-2.5 max-w-[970px] mx-auto">
                    {lang.list.map(({question, answer, color}, key) => {
                        let answerHtml = '';

                        answer.forEach((item) => {
                            if(Array.isArray(item)){
                                answerHtml += '<ul class="list-disc list-inside flex flex-col gap-3 -mt-5">';

                                item.forEach((subitem) => {
                                  answerHtml += `<li>${subitem}</li>`;
                                });

                                answerHtml += '</ul>';

                            }
                            else{
                                answerHtml += `<p>${item}</p>`;
                            }
                        });

                        return (
                            <article key={`AccordionItem: ${key}`}
                                     className={`bg-white rounded-[35px] ${key < 3 ? 'accent-blue-800' : 'accent-orange-800'}`}>
                                <div
                                    className="w-full bg-gradient-to-tr from-accent-color to-accent-color/50 text-white rounded-[35px] py-6 pl-10 pr-6 cursor-pointer"
                                    onClick={() => key === activeItem ? setActiveItem(null) : setActiveItem(key)}
                                >
                                    <header className="flex items-center justify-between gap-4">
                                        <h3 className="text-md md:text-lg font-semibold">{question}</h3>
                                        <button
                                            className="w-14 h-14 bg-white/25 shrink-0 rounded-full inline-flex items-center justify-center">
                                            <SvgArrowDown width={18}
                                                          className={`transform transition-transform duration-500 ${key === activeItem ? 'rotate-180' : ''}`}/>
                                        </button>
                                    </header>
                                    <div className={`accordion ${key === activeItem ? 'accordion-open' : ''}`}>

                                        <div className="py-6 max-w-[790px] flex flex-col gap-8"
                                             dangerouslySetInnerHTML={{__html: answerHtml}}/>
                                    </div>
                                </div>
                            </article>
                        )
                    })}
                </div>
            </Container>

            <SectionQuestions className="accent-blue-800">
                <Title>
                    {lang.questions.title.localize({emoji: '💬'})}
                </Title>
            </SectionQuestions>
        </MainLayout>
    )
}
